import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "empty_check",
    standalone: false
})
export class EmptyCheckPipe implements PipeTransform {
    transform(rawString: string | null): string {
        if (rawString == "" || rawString == null || rawString == "$0.00") {
            return "--";
        }
        return rawString;
    }
}